import { TASKS_OPTIONS } from '@/components/Dashboard/constants';

const removeOverviewTaskById = (tasks, taskId) =>
  tasks.filter((task) => task.id !== taskId);

export const markOverviewTaskCompleting = (tasks, taskId) =>
  tasks.map((task) =>
    task.id === taskId
      ? {
          ...task,
          completing: true,
        }
      : task
  );

export const resetOverviewTaskCompleting = (tasks, taskId) =>
  tasks.map((task) =>
    task.id === taskId
      ? {
          ...task,
          completing: false,
        }
      : task
  );

export const getNormalizedOverviewTasks = (payload = {}) => {
  const pendingTasks = payload.pending_tasks ?? [];
  const overdueTasks = payload.overdue_tasks ?? [];
  const counts = payload.counts ?? {};

  return {
    tasks: {
      [TASKS_OPTIONS.TODAY]: pendingTasks,
      [TASKS_OPTIONS.EXPIRED]: overdueTasks,
    },
    counts: {
      [TASKS_OPTIONS.TODAY]: counts.pending ?? pendingTasks.length,
      [TASKS_OPTIONS.EXPIRED]: counts.overdue ?? overdueTasks.length,
    },
  };
};

export const getOverviewTasksWithoutTask = (overviewTasks, taskId) => {
  const nextTodayTasks = removeOverviewTaskById(
    overviewTasks.tasks[TASKS_OPTIONS.TODAY],
    taskId
  );
  const nextExpiredTasks = removeOverviewTaskById(
    overviewTasks.tasks[TASKS_OPTIONS.EXPIRED],
    taskId
  );

  return {
    tasks: {
      [TASKS_OPTIONS.TODAY]: nextTodayTasks,
      [TASKS_OPTIONS.EXPIRED]: nextExpiredTasks,
    },
    counts: {
      [TASKS_OPTIONS.TODAY]: nextTodayTasks.length,
      [TASKS_OPTIONS.EXPIRED]: nextExpiredTasks.length,
    },
  };
};
